import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Label, Icon, SemanticCOLORS, Popup } from 'semantic-ui-react'
import styled from 'styled-components'

interface InlineDialogProps {
  style?: Object
  control: any
  color?: any
  text: string
  action: Function
}

const StyledLabel = styled(Label)`
display: flex !important;
align-items: center;
`

const InlineDialog: React.FC<InlineDialogProps> = ({ style, control, color, text, action }) => {
  const [expanded, setExpanded] = useState(false)
  const { t } = useTranslation()

  function renderExpanded() {
    return <StyledLabel color={color ? color : 'red'} size='large' style={style || {}}>
      {text}
      < Label.Detail as='a' onClick={() => {
        setExpanded(false)
        action()
      }}>
        <Popup
          content={t('Delete offer')}
          trigger={<Icon name='checkmark' />}
        />
      </Label.Detail >
      <Label.Detail as='a' onClick={() => setExpanded(false)}>
        <Popup
          content={t('Cancel delete offer')}
          trigger={<Icon name='cancel' />}
        />
      </Label.Detail>
    </StyledLabel >
  }

  return expanded ? renderExpanded() : React.cloneElement(control, {
    onClick: () => setExpanded(true)
  })
}
export default InlineDialog
